/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import notification from "../components/notification";

// Define a service using a base URL and expected endpoints
export const ClientApi = createApi({
  reducerPath: "ClientApi",
  baseQuery: fetchBaseQuery({
    // baseUrl: process.env.REACT_APP_API_URL,
    // baseUrl: 'https://api-myhcare.thesynergyworks.com/api/v1',
    baseUrl: "https://api-swasna.thesynergyworks.com/v1",
    // baseUrl: process.env.REACT_APP_BASENAME,
    prepareHeaders: (headers) => {
      if (localStorage.getItem("token"))
        headers.set("Authorization", localStorage.getItem("token"));
      return headers;
    },
  }),
  tagTypes: [],
  endpoints: (builder) => ({
    signUp: builder.mutation({
      query: ({ email, password, userName }) => ({
        url: "/sign-up",
        method: "POST",
        body: { email, password, userName },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          notification({
            title: "Sign up failed!",
            description:
              error?.error?.data?.message || "Unable to create your account",
            type: "error",
          });
        }
      },
    }),
    login: builder.mutation({
      query: ({ email, password }) => ({
        url: "/login",
        method: "POST",
        body: {
          email,
          password,
          role: "client",
        },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled.catch((error) =>
          notification({
            title: "Invalid credentials!",
            description:
              error?.error?.data?.message ||
              "Either your email or password is invalid",
            type: "error",
          }),
        );
      },
    }),
    verifyTwoFactorAuth: builder.mutation({
      query: ({ authCode, token }) => ({
        url: "/verifyTwoFactorAuth",
        method: "PUT",
        headers: { Authorization: token },
        body: { authCode, uuid: localStorage.getItem("uuid") },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled.catch((error) =>
          notification({
            title: "Invalid OTP!",
            description: "Please enter correct otp",
          }),
        );
      },
    }),
    forgotPassword: builder.mutation({
      query: ({ email, role }) => ({
        url: "/forgotPassword",
        method: "PUT",
        body: { email, role },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .then(() =>
            notification({
              title: "Email sent successfully!",
              description:
                "Check your email for directions to reset your password",
              type: "success",
            }),
          )
          .catch(() =>
            notification({
              title: "Invalid Email!",
              description: "No user found with that email",
              type: "error",
            }),
          );
      },
    }),
    resetPassword: builder.mutation({
      query: ({ forgotPasswordToken, password, confirmPassword }) => ({
        url: "/resetPassword",
        method: "PUT",
        body: { forgotPasswordToken, password, confirmPassword },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .then(() =>
            notification({
              title: "Password Updated!",
              description: "Please login to continue",
              type: "success",
            }),
          )
          .catch(() =>
            notification({
              title: "Unable to update password!",
              description:
                "Please ensure that the password reset link is correct",
              type: "error",
            }),
          );
      },
    }),
    changePassword: builder.mutation({
      query: ({ oldPassword, password, confirmPassword }) => ({
        url: "/changePassword",
        method: "PUT",
        body: { oldPassword, password, confirmPassword },
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSignUpMutation,
  useLoginMutation,

  useVerifyTwoFactorAuthMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
} = ClientApi;
